module.exports = "pegasus_template/assets/gray-large-twitter.png";